/**
 * Attach order usage from adjustments onto credit note list rows.
 */
export function enrichCreditNotesWithUsage(notes, adjustmentsByNoteId = {}) {
  return (Array.isArray(notes) ? notes : []).map((note) => {
    const adjustments = adjustmentsByNoteId[note.id] ?? [];
    const usage_projects = adjustments.map((a) => {
      const orderValue = Number(a.project_value) || 0;
      const totalCredit =
        Number(a.project_credit_total) || Number(a.value) || 0;
      const pending =
        a.pending_payment != null
          ? Number(a.pending_payment)
          : orderValue - totalCredit;
      return {
        project_id: a.project_id,
        project_name: a.project_name,
        project_value: orderValue,
        project_credit_total: totalCredit,
        pending_payment: pending,
        customer_name: a.customer_name,
        credit_applied: a.value,
        adjusted_at: a.adjusted_at,
      };
    });
    return { ...note, usage_projects };
  });
}
